import { lazy } from 'solid-js'
import { messages } from '../../pages/browser-demo-page/browser-demo-page-routing.messages.en.js'

/*
    TENANT-5307. Unlisted demo page for the commercial team.

    `noIndex: true` emits `noindex,follow`, and the path is deliberately absent
    from `sitemap-routes.js`. Neither of those stops someone who already has the
    URL — that is the accepted trade-off, not an oversight.
*/
export default {
    component: lazy(() => import('../../pages/browser-demo-page/browser-demo-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    noIndex: true,
    path: '/browser-demo',
    titleMessage: messages.titleMessage,
}
